import { parseStringPromise } from 'xml2js';
import { PAGE_TYPES, TYPE_TO_COMP_TYPE } from './constants.js';
const parsePageStructure = async (pageStructure) => {
    const parsedXml = await parseStringPromise(pageStructure);
    const elementTypes = Object.keys(parsedXml);
    if (elementTypes.length !== 1 || !PAGE_TYPES.has(elementTypes[0])) {
        throw new Error('Invalid page data');
    }
    return parsedXml;
};
const isKnownComponentType = (type) => type in TYPE_TO_COMP_TYPE;
const appendNodeToMap = (nicknamesToComponentTypesMap, node, nodeType) => {
    const { $, _, ...childrenGroups } = node;
    if ($.codeName) {
        nicknamesToComponentTypesMap[$.codeName] = isKnownComponentType(nodeType) ? TYPE_TO_COMP_TYPE[nodeType] : null;
    }
    for (const [type, children] of Object.entries(childrenGroups)) {
        for (const child of children) {
            appendNodeToMap(nicknamesToComponentTypesMap, child, type);
        }
    }
};
export const getNicknamesToComponentTypesMap = async (pageData) => {
    const nicknamesToComponentTypesMap = {};
    const parsedXml = await parsePageStructure(pageData.structure.content);
    const pageKey = Object.keys(parsedXml)[0];
    appendNodeToMap(nicknamesToComponentTypesMap, parsedXml[pageKey], pageKey);
    return nicknamesToComponentTypesMap;
};
